<template>
    <div class="create-schedule">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">

                        <form class="row g-3">
                            <div class="col-md-6">
                                <label for="user" class="form-label">Select Handyman <span class="text-danger">*</span></label>
                                <Select2
                                    name="handymanIds"
                                    v-model="scheduleData.handymanIds"
                                    :options="handymanOptions"
                                    :settings="{ multiple: true, minimumResultsForSearch: 'Infinity', selectionCssClass: 'hm-multiselect', placeholder: 'Select Handyman', }"
                                    class=""
                                />
                                <div class="is-invalid invalid-feedback">This field is required.</div>
                            </div>
                            <!-- Display the below fields only when handyman is selected -->
                            <template v-if="Object.keys(scheduleData.handymanIds).length > 0">
                                <div class="col-md-12">
                                    <label class="form-label">Select Schedule Type</label>
                                    <div class="d-flex gap-3">
                                        <div class="form-check form-switch">
                                            <input
                                                class="form-check-input"
                                                type="radio"
                                                id="repeats_weekly"
                                                value="repeats_weekly"
                                                v-model="scheduleData.scheduleType"
                                            >
                                            <label class="form-check-label cursor-pointer" for="repeats_weekly">Repeats Weekly</label>
                                        </div>
                                        <div class="form-check form-switch">
                                            <input
                                                class="form-check-input"
                                                type="radio"
                                                id="date_range"
                                                value="date_range"
                                                v-model="scheduleData.scheduleType"
                                            >
                                            <label class="form-check-label cursor-pointer" for="date_range">Date Range</label>
                                        </div>
                                    </div>

                                </div>
                                <template v-if="scheduleData.scheduleType === 'repeats_weekly'">
                                    <div class="col-md-6">
                                        <label class="form-label">Calendar Days (<small>into the future</small>)</label>
                                        <input
                                            class="form-control"
                                            type="number"
                                            v-model="scheduleData.calendarDays"
                                            placeholder="Enter number of days"
                                        />
                                    </div>
                                    <div class="col-md-12">
                                        <table class="table table-bordered align-middle">
                                            <tbody>
                                                <tr
                                                    v-for="(day, index) in scheduleData.weekDays"
                                                    :key="index"
                                                >
                                                    <td class="text-center" width="10%">{{ day.name.toUpperCase() }}</td>
                                                    <td width="80%">
                                                        <template v-if="Object.keys(day.times).length > 0">
                                                            <div
                                                                v-for="(time, timeIndex) in day.times"
                                                                class="d-flex gap-3 align-items-center"
                                                                :class="{'pb-2': Object.keys(day.times).length > 1 && timeIndex < Object.keys(day.times).length - 1}"
                                                            >
                                                                <Select2
                                                                    :name="'time_'+index"
                                                                    v-model="time.startTime"
                                                                    :options="timeOptions"
                                                                    :settings="{ minimumResultsForSearch: 'Infinity', selectionCssClass: 'handyman-time-select', width: '125px !important' }"
                                                                    class=""
                                                                />
                                                                <div>-</div>
                                                                <Select2
                                                                    :name="'time_'+index"
                                                                    v-model="time.endTime"
                                                                    :options="timeOptions"
                                                                    :settings="{ minimumResultsForSearch: 'Infinity', selectionCssClass: 'handyman-time-select', width: '125px !important' }"
                                                                    class=""
                                                                />
                                                                <i @click="removeTimeSlot(index, timeIndex)" class="bi bi-x-circle cursor-pointer"></i>
                                                            </div>
                                                        </template>
                                                        <template v-else>Unavailable</template>
                                                    </td>
                                                    <td class="text-center align-items-center" width="10%">
                                                        <i class="bi bi-plus-lg cursor-pointer fw-bold fs-5 me-2" @click="addTimeSlot(index)"></i>
                                                        <i class="bi bi-copy cursor-pointer" @click="displayFilterForDay ? displayFilterForDay = false : displayFilterForDay = day.dayOfWeek"></i>
                                                        <div
                                                            v-if="displayFilterForDay === day.dayOfWeek"
                                                            class="card position-absolute copy-to-days-container"
                                                        >
                                                            <div class="card-body gap-3 align-items-center text-start ps-3 pe-3">
                                                                <h6>COPY TO</h6>
                                                                <div
                                                                    v-for="(copyToDay, copyToDayIndex) in copyToDays"
                                                                    :key="copyToDayIndex"
                                                                    class="form-check"
                                                                >
                                                                    <template v-if="copyToDay.dayOfWeek===day.dayOfWeek">
                                                                        <input
                                                                            class="form-check-input"
                                                                            type="checkbox"
                                                                            checked="checked"
                                                                            disabled="disabled"
                                                                            :value="copyToDay.dayOfWeek"
                                                                            :id="'copyToDay_'+copyToDayIndex"
                                                                        >
                                                                        <label class="form-check-label" :for="'copyToDay_'+copyToDayIndex">{{ copyToDay.name }}</label>
                                                                    </template>
                                                                    <template v-else>
                                                                        <input
                                                                            class="form-check-input"
                                                                            type="checkbox"
                                                                            v-model="copyToDay.checked"
                                                                            checked
                                                                            :value="copyToDay.dayOfWeek"
                                                                            :id="'copyToDay_'+copyToDayIndex"
                                                                        >
                                                                        <label class="form-check-label cursor-pointer" :for="'copyToDay_'+copyToDayIndex">{{ copyToDay.name }}</label>
                                                                    </template>

                                                                </div>
                                                                <button @click="copyToSelectedDays(day.dayOfWeek)" type="button"class="btn btn-sm btn-theme w-100 mt-3">Apply</button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col-md-6">
                                        <label class="form-label">Select Date Range</label>
                                        <VueDatePicker
                                            v-model="scheduleData.scheduleDate"
                                            :enable-time-picker="false"
                                            range
                                            multi-calendars
                                        ></VueDatePicker>
                                    </div>
                                    <div class="col-md-12">
                                        <table class="table table-bordered align-middle">
                                            <tbody>
                                                <tr
                                                    v-for="(day, index) in scheduleData.monthDays"
                                                    :key="index"
                                                >
                                                    <td class="text-center" width="10%">
                                                        <div>{{ day.name.toUpperCase() }}</div>
                                                        <div>{{ day.displayDate }}</div>
                                                    </td>
                                                    <td width="80%">
                                                        <template v-if="Object.keys(day.times).length > 0">
                                                            <div
                                                                v-for="(time, timeIndex) in day.times"
                                                                class="d-flex gap-3 align-items-center"
                                                                :class="{'pb-2': Object.keys(day.times).length > 1 && timeIndex < Object.keys(day.times).length - 1}"
                                                            >
                                                                <Select2
                                                                    :name="'time_'+index"
                                                                    v-model="time.startTime"
                                                                    :options="timeOptions"
                                                                    :settings="{ minimumResultsForSearch: 'Infinity', selectionCssClass: 'handyman-time-select', width: '125px !important' }"
                                                                    class=""
                                                                />
                                                                <div>-</div>
                                                                <Select2
                                                                    :name="'time_'+index"
                                                                    v-model="time.endTime"
                                                                    :options="timeOptions"
                                                                    :settings="{ minimumResultsForSearch: 'Infinity', selectionCssClass: 'handyman-time-select', width: '125px !important' }"
                                                                    class=""
                                                                />
                                                                <i @click="removeTimeSlot(index, timeIndex)" class="bi bi-x-circle cursor-pointer"></i>
                                                            </div>
                                                        </template>
                                                        <template v-else>Unavailable</template>
                                                    </td>
                                                    <td class="text-center align-items-center" width="10%">
                                                        <i class="bi bi-plus-lg cursor-pointer fw-bold fs-5 me-2" @click="addTimeSlot(index)"></i>
                                                        <i class="bi bi-copy cursor-pointer" @click="displayFilterForDay ? displayFilterForDay = false : displayFilterForDay = day.date"></i>
                                                        <div
                                                            v-if="displayFilterForDay === day.date"
                                                            class="card position-absolute copy-to-days-container"
                                                        >
                                                            <div class="card-body gap-3 align-items-center text-start ps-3 pe-3">
                                                                <h6>COPY TO</h6>
                                                                <div class="overflow-auto" style="max-height: 200px;">
                                                                    <div
                                                                        v-for="(copyToDay, copyToDayIndex) in copyToDaysForMonth"
                                                                        :key="copyToDayIndex"
                                                                        class="form-check"
                                                                    >
                                                                        <template v-if="copyToDay.date===day.date">
                                                                            <input
                                                                                class="form-check-input"
                                                                                type="checkbox"
                                                                                checked="checked"
                                                                                disabled="disabled"
                                                                                :value="copyToDay.date"
                                                                                :id="'copyToDay_'+copyToDayIndex"
                                                                            >
                                                                            <label class="form-check-label" :for="'copyToDay_'+copyToDayIndex">{{ copyToDay.displayDate }}</label>
                                                                        </template>
                                                                        <template v-else>
                                                                            <input
                                                                                class="form-check-input"
                                                                                type="checkbox"
                                                                                v-model="copyToDay.checked"
                                                                                checked
                                                                                :value="copyToDay.date"
                                                                                :id="'copyToDay_'+copyToDayIndex"
                                                                            >
                                                                            <label class="form-check-label cursor-pointer" :for="'copyToDay_'+copyToDayIndex">{{ copyToDay.displayDate }}</label>
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                                <button @click="copyToSelectedDaysForMonth(day.date)" type="button"class="btn btn-sm btn-theme w-100 mt-3">Apply</button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </template>
                                <div class="col-12">
                                    <button
                                        type="button"
                                        class="btn btn-theme float-end"
                                        :disabled="Processing"
                                        :class="{'disabled': Processing}"
                                        v-text="Processing ? 'Processing...' : 'Create'"
                                        @click="createSchedule"
                                    ></button>
                                </div>
                            </template>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Select2 from 'vue3-select2-component';
import moment from 'moment';
import axios from 'axios';


export default {
    components: {
        Select2,
    },
    emits: ['select'], // Declare custom event here
    data() {
        return {
            Processing: false,
            handymanList: [],
            handymanOptions: [],
            timeOptions: [],
            scheduleData: {
                handymanIds: '',
                scheduleDate: null,
                scheduleType: 'repeats_weekly', // repeats_weekly or date_range
                calendarDays: 30,
                weekDays: [
                    { dayOfWeek: 1, name: 'Mon', times:[{startTime: '09:00', endTime: '17:00', status: 'available'}] },
                    { dayOfWeek: 2, name: 'Tue', times:[{startTime: '09:00', endTime: '17:00', status: 'available'}] },
                    { dayOfWeek: 3, name: 'Wed', times:[{startTime: '09:00', endTime: '17:00', status: 'available'}] },
                    { dayOfWeek: 4, name: 'Thu', times:[{startTime: '09:00', endTime: '17:00', status: 'available'}] },
                    { dayOfWeek: 5, name: 'Fri', times:[{startTime: '09:00', endTime: '17:00', status: 'available'}] },
                    { dayOfWeek: 6, name: 'Sat', times:[] },
                    { dayOfWeek: 0, name: 'Sun', times:[] },
                ],
                monthDays: [],
            },
            copyToDays:[
                { dayOfWeek: 1, name: 'Monday', checked: false },
                { dayOfWeek: 2, name: 'Tuesday', checked: false },
                { dayOfWeek: 3, name: 'Wednesday', checked: false },
                { dayOfWeek: 4, name: 'Thursday', checked: false },
                { dayOfWeek: 5, name: 'Friday', checked: false },
                { dayOfWeek: 6, name: 'Saturday', checked: false },
                { dayOfWeek: 0, name: 'Sunday', checked: false },
            ],
            copyToDaysForMonth: [],
            displayFilterForDay: false,
        }
    },
    created() {

    },
    mounted() {
        const rangeStart = moment();
        const rangeEnd = moment().add(30, 'days');
        this.scheduleData.scheduleDate = [rangeStart, rangeEnd];

        // Get handyman list
        this.getHandymanList();

        // Populate time options
        this.populateTimeOptions();

    },
    computed: {
        workingTimeOptions() {
            //let set = this.$s
        }

    },
    methods: {
        getHandymanList() {
            let self = this;
            axios.post('/admin/handymans/get-handymans')
                .then(response => {
                    self.handymanList = response.data.handymans;

                    // Push the name and id into the options
                    response.data.handymans.forEach((handyman) => {
                        self.handymanOptions.push({id: handyman.id, text: handyman.full_name});
                    });
                });
        },
        populateTimeOptions() {
            this.timeOptions = [];
            const startTime = moment().startOf('day'); // Start at 12:00 AM
            const endTime = moment().endOf('day'); // End at 11:59 PM

            let currentTime = startTime;

            while (currentTime <= endTime) {
                // Custom format for hours without leading zero
                let hour = currentTime.format('h');
                let minute = currentTime.format('mm');
                let ampm = currentTime.format('A');

                // Concatenating hour, minute, and AM/PM without space for the 'text'
                const text = `${hour}:${minute} ${ampm}`;

                // Keeping the ID in 24-hour format for consistency
                const id = currentTime.format('HH:mm');

                this.timeOptions.push({ id, text });

                // Increment by 5 minutes
                currentTime.add(15, 'minutes');
            }
        },

        // Remove the time from the times array
        removeTimeSlot(dayIndex, timeIndex) {
            // Check if scheduleType is repeats_weekly
            if(this.scheduleData.scheduleType == 'repeats_weekly') {
                this.scheduleData.weekDays[dayIndex].times.splice(timeIndex, 1);
            }
            else if(this.scheduleData.scheduleType == 'date_range') {
                this.scheduleData.monthDays[dayIndex].times.splice(timeIndex, 1);
            }
        },

        // Add the time to the times array
        addTimeSlot(dayIndex) {
            // Check if scheduleType is repeats_weekly
            if(this.scheduleData.scheduleType == 'repeats_weekly') {
                this.scheduleData.weekDays[dayIndex].times.push({startTime: '09:00', endTime: '17:00', status: 'available'});
            }
            else if(this.scheduleData.scheduleType == 'date_range') {
                this.scheduleData.monthDays[dayIndex].times.push({startTime: '09:00', endTime: '17:00', status: 'available'});
            }

        },

        copyToSelectedDays(copyDay) {
            // Find the day from the schedule weekDays array by day
            // Access the weekDays array
            const weekDays = this.scheduleData.weekDays;

            // 1. Find the data for copyDay in the scheduleData object
            const dayData = weekDays.find(day => day.dayOfWeek === copyDay);

            if(dayData) {
                // 2. Find the days that are checked: true in the copyToDays array
                const enabledDays = this.copyToDays.filter(day => day.checked === true).map(day => day.dayOfWeek);

                if(enabledDays.length > 0) {
                    // 3. Replace the times in scheduleData for each enabled day with the times from day=4
                    this.scheduleData.weekDays.forEach(weekDay => {
                        if (enabledDays.includes(weekDay.dayOfWeek)) {
                            weekDay.times = JSON.parse(JSON.stringify(dayData.times));
                        }
                    });
                }
            }

            // Hide the filter
            this.displayFilterForDay = false;

            // Mark all days as not checked
            this.copyToDays.forEach(day => {
                day.checked = false;
            })
        },

        // Copy to selected days for the month
        copyToSelectedDaysForMonth(copyDate) {
            // Access the monthDays array
            const monthDays = this.scheduleData.monthDays;

            // 1. Find the data for copyDay in the scheduleData object
            const dayData = monthDays.find(day => day.date == copyDate);

            if(dayData) {
                // 2. Find the days that are checked: true in the copyToDaysForMonth array
                const enabledDays = this.copyToDaysForMonth.filter(day => day.checked === true).map(day => day.date);

                if(enabledDays.length > 0) {
                    // 3. Replace the times in scheduleData for each enabled day with the times from day=4
                    this.scheduleData.monthDays.forEach(monthDay => {
                        if (enabledDays.includes(monthDay.date)) {
                            monthDay.times = JSON.parse(JSON.stringify(dayData.times));
                        }
                    });
                }
            }

            // Hide the filter
            this.displayFilterForDay = false;

            // Mark all days as not checked
            this.copyToDaysForMonth.forEach(day => {
                day.checked = false;
            })
        },

        // Generate the days for the month data
        generateDaysForMonth() {
            // Check if the start and end dates are valid
            if(this.scheduleData.scheduleDate) {
                const startDate = moment(this.scheduleData.scheduleDate[0]);
                const endDate = moment(this.scheduleData.scheduleDate[1]);
                let currentDate = startDate.clone();

                // Initial empty list
                this.copyToDaysForMonth = [];
                this.scheduleData.monthDays = [];

                while (currentDate <= endDate) {
                    // Format and add the current date to the list
                    this.scheduleData.monthDays.push({
                        dayOfWeek: currentDate.day(), // Moment.js: 0 (Sunday) to 6 (Saturday)
                        name: currentDate.format('ddd'), // Abbreviated day name (Mon, Tue, etc.)
                        date: currentDate.format('DD/MM/YYYY'),
                        displayDate: currentDate.format('DD/MM'),
                        times: []
                    });

                    // Display date like MArch 24, 2024

                    // Prepare the filter data
                    this.copyToDaysForMonth.push({
                        dayOfWeek: currentDate.day(),
                        dayName: currentDate.format('dddd'),
                        date: currentDate.format('DD/MM/YYYY'),
                        displayDate: currentDate.format('MMMM DD, YYYY'),
                        checked: false
                    });

                    // Move to the next day
                    currentDate.add(1, 'days');
                }
            }

        },

        createSchedule() {
            let self = this;
            this.Processing = true;
            axios.post('/admin/handymans/store-schedule', self.scheduleData)
                .then(response => {
                    if (response.data.status == 'success') {
                        window.location.href = response.data.redirect_url;
                    }
                });
        }
    },
    watch: {
        'scheduleData.scheduleDate'(newVal, oldVal) {
            if (newVal[0] && newVal[1]) {
                this.generateDaysForMonth();
            }
        }
    }
}
</script>
<style>
.select2-container--open .select2-dropdown--below{
    z-index: 99999;
}
</style>
